import { defineNuxtRouteMiddleware, useAsyncData } from '#imports'
import { useFeatureFlipping, checkFeatures, applyFeatureFlippingResponse } from '@b2ag/feature-flipping'
import { useAuthService } from '@b2ag/auth'
import { getAppContext } from '@b2ag/micro-front-tools'
import { useUserData } from '@b2ag/user-data'

const { isFrontTech } = getAppContext()
let initializedWithAuth = false

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.oauthWorkflow) return

  if (import.meta.server) {
    const { data } = await useAsyncData('feature-flipping-global', () => checkFeatures())
    if (data.value) applyFeatureFlippingResponse(data.value)
    return
  }

  const isAuthenticated = await useAuthService().isAuthenticated()

  if (isAuthenticated) {
    if (initializedWithAuth) return

    const userData = useUserData()
    if (!userData.isUserLoaded.value) return

    const partnerId = userData.currentDistributorId.value
    const membershipCode = isFrontTech
      ? userData.targetCustomerMembership.value
      : userData.currentMembershipNumber.value

    if (partnerId) {
      await useFeatureFlipping().updateFeatureFlipping(partnerId, membershipCode)
      initializedWithAuth = true
    }
  } else {
    // Client anonymous: hydrate refs from SSR payload (no API call)
    const { data } = await useAsyncData('feature-flipping-global', () => checkFeatures())
    if (data.value) applyFeatureFlippingResponse(data.value)
  }
})
